import React, { useState } from 'react';
import "../App.css";
import { Link, useHistory } from "react-router-dom";
import { Avatar, Dropdown, Menu } from 'antd';
import { auth } from "../config/fire";
import { signout } from '../helpers/auth';
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import CreateMeetModal from '../components/Modals/createMeetModal';
import Logo from '../images/favicon.png';

export const Container = styled.div`
width:100%;
display:flex;
padding: 1.5rem 2rem;
align-items: center;
justify-content: space-between;
.ant-dropdown {
  width: 450px !important;
  padding:0px 10px !important;
  border-radius: 15px !important;
}
.ant-dropdown-menu{
  width: 450px !important;
  border-radius: 15px !important;
}
.logo{
  font-weight: 700;
  font-size: 22px;
  font-family: cursive;
  color: black;
}
a{
  font-size: 15px;
  font-weight: 500;
  color: #232323c7;
  &:hover {
    color: #232323c7;
    text-decoration: none;
  }
}
.meet-link{
  margin:0 !important;
  font-size: 15px;
  font-weight: 500;
  color: #232323c7;
  padding: 0px 15px;
  cursor:pointer;
}

`;
export const LinkContainer = styled.div`
display:flex;
align-items: center;
.profile_link{
  padding:0px 15px;
}
.profile_picture{
  display:flex;
  align-items: center;
  justify-content:center;
}
.register-button{
  box-shadow: rgb(50 50 93 / 9%) 5px 10px 10px -5px, rgb(0 0 0 / 30%) 0px 8px 16px -8px;
  padding: 7px 25px;
  border-radius: 25px;
  border-top: 1px solid #0000000a;
  margin-right: 20px;
  cursor: pointer;
}
.avatar-user{
  // background-image: linear-gradient(to right,#41d4b3, #067D68);
  margin-left: 10px;
}

`;
export const MenuContainer = styled(Menu)`
width: 250px !important;
.user_dropdown{
  display:flex;
  align-items: center;
}
a{
  text-decoration: none;
}
.ant-avatar{
  display:flex;
  align-items: center;
  justify-content:center;
}

`;

export const UserDetails = styled.div`
padding-left: 12px;
padding-top: 10px;
p{
  font-size: 14px; 
  line-height: 5px;
}
`;

export const UserDetailsCard = styled.div`
display: flex;
flex-direction: column;
font-family: Roboto;
border-radius: 15px;
width:100%;
p{
  margin-bottom: 5px;
}
.fa-icon{
  margin-right:10px;
}
.ant-dropdown-menu-item{
padding-left:20px;
text-align:center;
}
.ant-dropdown-menu-item:hover {
  background-color: #e6e6e629 !important;
}
.ant-dropdown-menu-title-content {
  display: flex;
  align-items: center;
}
.welcome-text{
font-size: 15px;
font-weight: 600;
color: rgb(64 64 64);
}
.user-email{
  font-size: 14px;
  font-weight: 500;
  color: #000000ad;
}
.logout-btn{
  font-size: 14px;
  font-weight: 500;
  background-image: linear-gradient(to right,#41d4b3,#067D68);
  width: 100%;
  color: white;
  padding: 5px;
  border-radius: 5px;
  margin:10px 0px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
}
.prof-names{
display: flex;
flex-direction: column;
align-items: baseline;
padding-left:10px;
}
.hover-style{
  padding-left: 10px;
  color: #000000ad;
  margin-bottom: 5px;
  a{
    color: #000000ad;
  }
  &:hover{
  font-size: 15px;
  font-weight: 600;
}
}
`;

export const EditButton = styled.button`
border: none;
outline: none;
border-radius: 5px;
width: 180px;
height: 40px;
font-size: 15px;
font-weight: 600;
background-image: linear-gradient(to right,#41d4b3, #067D68);
color: white;
margin-top: 10px;
box-shadow: rgb(136 165 191 / 48%) 6px 2px 16px 0px, rgb(255 255 255 / 80%) -6px -2px;
`;

const menu = (
  <MenuContainer>
    {
      auth().currentUser &&
      <UserDetailsCard>
        <Menu.Item>
          <Avatar size={50}
            src='https://cliply.co/wp-content/uploads/2020/10/442010811_HEADPHONES_AVATAR_3D_400.png' />
          <div className='prof-names'>
            <p className='welcome-text'>
              {auth().currentUser.displayName}</p>
            <p className='user-email'>{auth().currentUser.email}</p>
          </div>
        </Menu.Item>
        <Menu.Item>
          <Link to='/UserProfile' target="_blank" className='user-email hover-style'>Edit Profile</Link>
        </Menu.Item>
        <Menu.Item>
          <p className='logout-btn' onClick={() => { auth().signOut() }} >
            <FontAwesomeIcon className='fa-icon' icon={faSignOutAlt} />
            Logout
          </p>
        </Menu.Item>
      </UserDetailsCard>
    }
  </MenuContainer>
);

const Head = (props) => {
  const [modalVisibility, setModalvisibility] = useState(false);
  let history = useHistory();
  return (
    <Container>
      <div>
        <Link className='logo' to="/">
          <img src={Logo}></img>
          <text>Ticqu</text>
        </Link>
      </div>
      <LinkContainer>
      {
        auth().currentUser && 
        <>
        <button onClick={() => signout() }>Logout</button>
        </>
      }
        {
          auth().currentUser &&
          <>
            <Link className='profile_link' >Blog</Link>
            <Link to='/MyEvents' className='profile_link'>MyEvents</Link>
          </>
        }
        {
          !auth().currentUser && <p onClick={() => props.HandleActionSelection('login')}
            className='meet-link register-button' style={{ marginRight: '20px' }}>LogIn</p>
        }
        {
          !auth().currentUser && <p className='meet-link register-button'
            onClick={() => props.HandleActionSelection('register')}
          >Register</p>
        }

        {
          auth().currentUser &&
          <Dropdown overlay={menu} placement="bottomLeft"
            // trigger={['click']}
            className='profile_link profile_picture'>
              
            <Avatar className='avatar-user' size={50}
              src="https://cliply.co/wp-content/uploads/2020/10/442010811_HEADPHONES_AVATAR_3D_400.png"
            />
          </Dropdown>
        }
      </LinkContainer>
      {
        modalVisibility &&
        <CreateMeetModal
          visibility={modalVisibility}
          onClose={() => setModalvisibility(false)}
        />
      }
    </Container >
  );
}
export default Head;
